import {
  Box,
  Button,
  Chip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { CheckCircleOutline, WarningAmber } from '@mui/icons-material';
import { useTheme } from '@mui/material';

const ConflictDialog = ({ open, onClose, conflictsData, conflictCount }) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningAmber color="warning" />
          Schedule Conflicts - {conflictCount} found
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {conflictsData?.conflicts?.length > 0 ? (
          <Box>
            {conflictsData.conflicts.map((c, i) => (
              <Box key={i} p={1.5} mb={1} borderRadius={1} bgcolor={theme.palette.action.hover}>
                <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                  <Chip label={c.type === 'duplicate_flight_no' ? 'Dup Flight No' : 'Slot Conflict'}
                    size="small" color="warning" />
                  {c.airport && <Chip label={c.airport} size="small" variant="outlined" />}
                  {c.time && <Typography variant="body2" fontFamily="monospace">{c.time}</Typography>}
                  <Chip label={`Days: ${c.sharedDays}`} size="small" />
                </Box>
                <Box display="flex" gap={1} flexWrap="wrap">
                  {c.flights?.map((f) => (
                    <Chip key={f.id} label={`${f.flightNo} ${f.dep}-${f.arr}`}
                      size="small" variant="outlined" icon={<CheckCircleOutline />} />
                  ))}
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Box display="flex" alignItems="center" gap={1} py={2}>
            <CheckCircleOutline color="success" />
            <Typography>No conflicts found.</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConflictDialog;
